import React, { FC } from 'react';
import { IoNotificationsOutline } from 'react-icons/io5';

import { ActionIcon, Indicator, Tooltip } from '@mantine/core';

import { InboxDrawer } from 'components/inbox/InboxDrawer';
import { useInbox } from 'hooks/use-inbox';
import { NotificationService } from 'services/NotificationService';

const InboxButton: FC = () => {
    const { unreadCount } = useInbox();

    return (
        <>
            <Tooltip label="Inbox" offset={10}>
                <Indicator
                    label={unreadCount}
                    disabled={unreadCount === 0}
                    color="red"
                    offset={7}
                    size={12}
                    styles={{ indicator: { fontSize: 8 } }}
                >
                    <ActionIcon onClick={() => NotificationService.openInbox()} variant="subtle" radius={99} size="lg">
                        <IoNotificationsOutline size={20} />
                    </ActionIcon>
                </Indicator>
            </Tooltip>

            <InboxDrawer />
        </>
    );
};

export { InboxButton };
